export enum MixpanelEvent {
  APP_INICIALIZADO = 'APP_INICIALIZADO',
  TELA_LOGIN_INICIO_SESSAO = 'TELA_LOGIN_INICIO_SESSAO',
  TELA_LOGIN_ERRO = 'TELA_LOGIN_ERRO',
  TELA_LOGOUT = 'TELA_LOGOUT',
  TELA_VISUALIZADA = 'TELA_VISUALIZADA',
  API_CHAMADA = 'API_CHAMADA',
  CLICK_CRIAR_NOVA_PROPOSTA = 'CLICK_CRIAR_NOVA_PROPOSTA',
  CLICK_EDITAR_PROPOSTA = 'CLICK_EDITAR_PROPOSTA',
  CLICK_ENVIAR_PROPOSTA_APROVACAO = 'CLICK_ENVIAR_PROPOSTA_APROVACAO',
  CLICK_EXCLUIR_PROPOSTA = 'CLICK_EXCLUIR_PROPOSTA',
  PROPOSTA_EXCLUIDA = 'PROPOSTA_EXCLUIDA',
  FORMULARIO_ACESSADO = 'FORMULARIO_ACESSADO',
  PROPOSTA_RASCUNHO_SALVO = 'PROPOSTA_RASCUNHO_SALVO',
  PROPOSTA_ENVIADA_APROVACAO = 'PROPOSTA_ENVIADA_APROVACAO',
  METRICAS_CONVERSAO_ATUALIZADAS = 'METRICAS_CONVERSAO_ATUALIZADAS',
}

export enum NomeTela {
  TELA_LOGIN = 'Tela de Login',
  LISTA_PROPOSTAS = 'Lista de Propostas',
  CALLBACK_AUTENTICACAO = 'Callback de Autenticação',
  CRIAR_PROPOSTA = 'Criar Proposta',
  EDITAR_PROPOSTA = 'Editar Proposta',
  TELA_DESCONHECIDA = 'Tela Desconhecida',
}
